import { render, staticRenderFns } from "./IconSmartphone.vue?vue&type=template&id=1461ef28&"
import script from "./IconSmartphone.vue?vue&type=script&lang=js&"
export * from "./IconSmartphone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports